import { CheckoutWidgetsBuilderState } from "@redotech/redo-conversion-core-common/checkouts/checkout-widgets-builder";
import { CheckoutOptimizationWidgetType } from "@redotech/redo-conversion-core-common/checkouts/widget";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import * as css from "./details-shipping-option-widget-preview.module.css";
import { ExampleShippingOption } from "./render-after-shipping-option-widget-preview";

export const DetailsShippingOptionWidgetPreview = memo(
  function DetailsShippingOptionWidgetPreview({
    widget,
  }: {
    widget: NonNullable<
      CheckoutWidgetsBuilderState["checkoutWidgets"][CheckoutOptimizationWidgetType.SHIPPING_OPTION_CONTENT]
    >;
  }) {
    return (
      <ExampleShippingOption bottomRadii="lg" topRadii="lg">
        {/* Widget preview */}
        <Flex
          align="center"
          borderRadius="xl"
          dir="row"
          gap="md"
          p="md"
          style={{ backgroundColor: widget.backgroundColor }}
        >
          {widget.imageUrl && (
            <img
              alt={widget.title}
              className={css.shippingOptionImage}
              src={widget.imageUrl}
            />
          )}
          <Flex dir="column" gap="xs">
            {widget.title && (
              <Text fontSize="xs" fontWeight="semibold" textColor="primary">
                {widget.title}
              </Text>
            )}
            {widget.description && (
              <Text fontSize="xs" textColor="secondary">
                {widget.description}
              </Text>
            )}
          </Flex>
        </Flex>
      </ExampleShippingOption>
    );
  },
);
